export default {
  BLUE: '#0082C7',
  ORANGE: '#ff8d2e',
  BLACK: '#101010',
  GRAY_DARKER: '#2E2E2E',
  GRAY_DARK: '#999999',
  GRAY: '#D5D5D5',
  GRAY_LIGHT: '#E7E7E7',
  GRAY_LIGHTER: '#F5F5F5',
  WHITE: '#FFFFFF',
  GREEN: '#7dbe38',
  RED: '#DD0000',
}



// WEBPACK FOOTER //
// ./src/constants/color-palette.js